import { ComponentProps, ReactNode } from 'react';
import { StyletronStyle } from '@activebrands/core-web/types/styletron';
import ThemeButton from 'components/buttons/ThemeButton';
import StateIcon from 'components/icons/StateIcon';

interface ArrowButtonProps extends ComponentProps<typeof ThemeButton> {
    children?: ReactNode;
    direction?: 'arrow-left' | 'arrow-right' | 'left' | 'right';
    iconSize?: string;
    iconStyling?: StyletronStyle;
    state?: string;
}

const ArrowButton = ({
    $style = {},
    children,
    direction = 'right',
    iconSize = '18px',
    state = 'arrow-right',
    theme = 'default',
    iconStyling = {},
    ...rest
}: ArrowButtonProps) => (
    <ThemeButton
        $style={{
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            ...$style,
        }}
        theme={theme}
        {...rest}
    >
        {direction === 'left' && (
            <StateIcon $style={{ marginRight: '8px', ...iconStyling }} size={iconSize} state={state} />
        )}
        {children}
        {direction === 'right' && (
            <StateIcon $style={{ marginLeft: '8px', ...iconStyling }} size={iconSize} state={state} />
        )}
    </ThemeButton>
);

export default ArrowButton;
